// import { CountUp } from "countup.js";
import { CountUp } from "./../../../node_modules/countup.js/dist/countUp";
import ViewabilityHelper from "viewability-helper";
// import { debounce } from "./bundle/rcobiella-helpers.js";

jQuery(function ($) {
	/* ---------------------------------------------------------------- */
	/*                             Count UP                             */
	/* ---------------------------------------------------------------- */
	var $countUpEls = $(".count-up");

	$countUpEls.each(function () {
		let $dis = $(this),
			dis = this,
			countTo = $dis.text();

		let countUpEl = new CountUp(this, countTo, {
			duration: 4,
			separator: ".",
		});
		if (!countUpEl.error) {
			let countUpObserver = new ViewabilityHelper(dis, function () {
				countUpEl.start();
			});
			countUpObserver.observe({
				unobserve: true,
				intersectPercentage: "1",
			});

			//countUpEl.start();
		} else {
			console.error("countup error", countUpEl.error);
		}
	});

	/* ---------------------------------------------------------------- */
	/*                             TARIFAS                              */
	/* ---------------------------------------------------------------- */

	let $tarifasWrapper = $(".tarifas-wrapper");
	if ($tarifasWrapper.length) {
		$tarifasWrapper.each(function () {
			let $dis = $(this),
				$titles = $dis.find(".tarifas-header-title"),
				$checks = $dis.find(".tarifas-check"),
				$cols = $dis.find(".tarifas-header-col");

			$cols.on("click", function () {
				let $_dis = $(this),
					$_check = $_dis.find(".tarifas-check"),
					$_parent = $_dis;

				$dis.removeClass("is-extra");
				$_check.toggleClass("is-selected");
				$_parent.toggleClass("is-selected");

				// If it's selected
				if ($_check.hasClass("is-selected")) {
					$_dis
						.siblings(".tarifas-header-col")
						.removeClass("is-selected")
						.find(".tarifas-check")
						.removeClass("is-selected");
					if ($_check.hasClass("check-extra")) {
						$dis.addClass("is-extra");
					}
				} else {
					// if it's not selected
					let $_othercheck = $_dis
						.siblings(".tarifas-header-col")
						.find(".tarifas-check");
					$_othercheck.addClass("is-selected");
					if ($_othercheck.hasClass("check-extra")) {
						$dis.addClass("is-extra");
					}
				}
			});
		});
	}
});
